import { Dispatch } from 'redux';
import { ApiAppeal } from '../http';
import { appealActions } from '../slices/appeal-slice';

const {
  setAppealListRequest,
  setAppealListSuccess,
  setAppealListFailure,
  setAppealListDefault,
  setAppealCurrentDefault,
  setAppealCurrentRequest,
  setAppealCurrentSuccess,
  setAppealCurrentFailure,
  setNewAppealRequest,
  setNewAppealSuccess,
  setNewAppealFailure,
  setNewAppealDefault,
  setAppealRequest,
  setAppealSuccess,
  setAppealFailure,
} = appealActions;

//List
export const getAppeals = (params?: Record<string, any>) => async (dispatch: Dispatch<any>) => {
  dispatch(setAppealListRequest());
  try {
    const data = await ApiAppeal.fetchAll(params);
    dispatch(setAppealListSuccess(data));
  } catch ({ message }) {
    dispatch(setAppealListFailure({ message }));
  }
};
export const clearAppeals = () => async (dispatch: Dispatch<any>) => {
  dispatch(setAppealListDefault());
};

export const getCurrentAppeal = () => async (dispatch: Dispatch) => {
  dispatch(setAppealCurrentRequest());
  try {
    const data = await ApiAppeal.getCurrent();
    dispatch(setAppealCurrentSuccess(data));
  } catch (error) {
    dispatch(setAppealCurrentFailure(error));
  }
};
export const clearCurrentAppeal = (data: Record<string, any>) => async (dispatch: Dispatch) => {
  dispatch(setAppealCurrentDefault());
};

export const setNewAppeal = (data: Record<string, any>) => async (dispatch: Dispatch) => {
  dispatch(setNewAppealRequest());
  try {
    await ApiAppeal.createOne(data);
    dispatch(setNewAppealSuccess());
  } catch (error) {
    dispatch(setNewAppealFailure(error));
  }
};
export const clearAppealRequest = () => async (dispatch: Dispatch) => {
  dispatch(setNewAppealDefault());
};

export const setAppealConfirm = (data: Record<string, any>) => async (dispatch: Dispatch) => {
  dispatch(setAppealRequest());
  try {
    await ApiAppeal.confirm(data);
    dispatch(setAppealSuccess());
  } catch (error) {
    dispatch(setAppealFailure(error));
  }
};

export const setAppealDecline = (data: Record<string, any>) => async (dispatch: Dispatch) => {
  dispatch(setAppealRequest());
  try {
    await ApiAppeal.decline(data);
    dispatch(setAppealSuccess());
  } catch (error) {
    dispatch(setAppealFailure(error));
  }
};
